import { Temporal } from 'temporal-polyfill'

const relativeTimeFormat = new Intl.RelativeTimeFormat()

const oneHourInSeconds = 60 * 60
const oneDayInSeconds = oneHourInSeconds * 24

export type FromNowOptions = Readonly<{
  now: Temporal.Instant
  defaultMessage?: string
  defaultMessageThresholdSeconds?: number
}>

const defaultFromNowOptions = (): FromNowOptions => ({
  now: Temporal.Now.instant(),
})

export const fromNow = (instant: string | Temporal.Instant, options: Partial<FromNowOptions> = {}): string => {
  const { now, defaultMessage, defaultMessageThresholdSeconds } = { ...defaultFromNowOptions(), ...options }
  const duration = Temporal.Instant.from(instant).since(now)
  const { sign } = duration
  const seconds = Math.abs(Math.round(duration.total('seconds')))

  if (defaultMessageThresholdSeconds !== undefined && seconds < defaultMessageThresholdSeconds) {
    return defaultMessage ?? ''
  } else if (seconds < 60) {
    return relativeTimeFormat.format(sign * seconds, 'second')
  } else if (seconds < oneHourInSeconds) {
    return relativeTimeFormat.format(sign * Math.round(seconds / 60), 'minute')
  } else if (seconds < oneDayInSeconds) {
    return relativeTimeFormat.format(sign * Math.round(seconds / oneHourInSeconds), 'hour')
  } else  {
    const days = Math.round(Math.abs(duration.total('days')))
    if (days < 100) {
      return relativeTimeFormat.format(sign * days, 'days')
    } else {
      return relativeTimeFormat.format(sign * Math.round(days / 30.42), 'month')
    }
  }
}
